import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTruck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h2.6a2 2 0 0 1 1.6.8l2.4 3.2a2 2 0 0 1 .4 1.2V16a1 1 0 0 1-1 1h-1.05a3.5 3.5 0 0 1-6.9 0h-3.1a3.5 3.5 0 0 1-6.9 0H2a1 1 0 0 1-1-1V5zm14 4v4h5v-1.47L17.6 9H15zM3 5v10h.6a3.5 3.5 0 0 1 6.8 0H13V5H3zm4 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm10 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTruck);
export default ForwardRef;
